FontAwesomeConfig = { searchPseudoElements: true };
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/brands';
import { Fancybox } from "@fancyapps/ui";

jQuery(document).ready(function($) {
    /* ====================== SHOW IE11 NOTIFICATION ====================== */
    function showBrowserAlert() {
        var ie11True = false;
        // true on IE11, false on Edge and other IEs/browsers.
        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode,
            ua = window.navigator.userAgent,
            array, // Declare the array variable
            version; // Declare the version variable

        if (ua.indexOf("AppleWebKit") > 0) {
            ie11True =  false;
        } else if (ua.indexOf("Lunascape") > 0) {
            ie11True =  false;
        } else if (ua.indexOf("Sleipnir") > 0) {
            ie11True =  false;
        } else {
            array = /(msie|rv:?)\s?([\d\.]+)/.exec(ua);
            version = (array) ? array[2] : '';

            ie11True = (version === 11 || version == 11.0 || version == 10 || version == 10.0) ? true : false;      
        }

        if (ie11True) {
            $('<div class="unsupported-browser unsupported-browser--active"><div class="unsupported-browser__inner"><h3>Sorry about this, but...</h3><p>It looks like you\'re using Internet Explorer 10 or 11. Parts of this website may not work or display correctly. Please consider using a different browser.</p> <ul class="unsupported-browser__links"><li><a href="https://www.google.com/intl/en_uk/chrome/" target="_blank" class="unsupported-browser__link unsupported-browser__link--chrome" aria-label="Download Chrome"></a></li><li><a href="https://www.microsoft.com/en-us/edge" target="_blank" class="unsupported-browser__link unsupported-browser__link--edge" aria-label="Download Microsoft Edge" ></a></li><li><a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank" class="unsupported-browser__link unsupported-browser__link--firefox" aria-label="Download Firefox"></a></li></ul></div></div>').prependTo('body');
        }
    }

    showBrowserAlert();
    
/* ====================== REMOVE EMPTY P TAG ======================  */
    $('p').each(function() {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
            $this.remove();
    });

/* ====================== FANCYBOX FUNCTIONS ======================  */
    let triggerEl;

    Fancybox.bind("[data-fancybox]", {
      on: {
        done: (fancybox, slide) => {
          triggerEl = slide.triggerEl;
          if (triggerEl) {
            if (fancybox.state === 1) {
              triggerEl.setAttribute("aria-expanded", "true");
            }
          }
        },
        close: (fancybox, slide) => {
          if (triggerEl) {
            triggerEl.setAttribute("aria-expanded", "false");
          }
        },
      },
    });

/* ====================== FUNCTION TO CHECK IF ELEMENT IS IN VIEWPORT ======================  */
    function isElementInViewport(element) {
        var $element = $(element);

        // Get the element's position and dimensions relative to the viewport
        var elementTop = $element.offset().top;
        var elementBottom = elementTop + $element.height();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        // Check if any part of the element is within the viewport
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

/* ====================== NAV MENU ITEM ======================  */

    function mobile_nav() {
        $('.nav li.menu-item-has-children > .menu-item__toggle').on("click", function(e) {
            $( ".nav li.menu-item-has-children" ).not($(this).parents('.menu-item-has-children')).removeClass('active');

            if($(this).attr('aria-expanded') === 'false') {
                $(this).parent().addClass('active');
                $(this).attr('aria-expanded', 'true');
                $(this).next('.mega-menu__wrap').addClass('open');
                $(this).next('.sub-menu').addClass('open');
                
            } else if($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
                $(this).parent().removeClass('active');
                $(this).next('.mega-menu__wrap').removeClass('open');
                $(this).next('.sub-menu').removeClass('open');
            }
        });

        if($(window).width() <= 1025) {
            
            $('.nav li.back-step .back-to-menu').on("click", function(e) {
                $(this).parent().parent('.sub-menu.open').removeClass('open');
                $(this).parent().parent().parent().find('.menu-item__toggle').attr('aria-expanded', 'false');

                $(this).parent().parent().parent().parent('.mega-menu__wrap.open').removeClass('open');
                $(this).parent().parent().parent().parent().parent().find('.menu-item__toggle').attr('aria-expanded', 'false');
            });

            $('.header__top__nav-toggle').on("click", function(e) {
                var $button = $(this);
                var currentExpanded = $button.attr('aria-expanded');
                var newExpanded = currentExpanded === 'true' ? 'false' : 'true';
                $button.attr('aria-expanded', newExpanded)

                $('.header__navigation').toggleClass('open');

                if($('.header__navigation').hasClass('open')) {
                    $('.header__top__nav-toggle__label').html('<i class="fa-solid fa-xmark"></i>Close');
                    window.scrollTo(0, 0);
                    $("html, body").addClass("noscroll");
                } else {
                    $('.header__top__nav-toggle__label').html('<i class="fa-solid fa-bars"></i>Menu');
                    $("html, body").removeClass("noscroll");
                    $( ".header__navigation .mega-menu__wrap").removeClass('open');
                    $( ".header__navigation .sub-menu").removeClass('open');
                    $('.nav li.menu-item-has-children > .menu-item__toggle').attr('aria-expanded', 'false');
                }
            });
        };
    };

    mobile_nav();


    /* ====================== MOBILE SEARCH TOGGLE ======================  */
    function mobile_search() {
        if($(window).width() <= 1025) {
            $( ".header__top__mobile-search").on('click', function(e) {
              var $button = $(this);
              var currentExpanded = $button.attr('aria-expanded');
              var newExpanded = currentExpanded === 'true' ? 'false' : 'true';
              $('.header__top__search').toggleClass('header__top__search--active');
              $button.attr('aria-expanded', newExpanded);

              var $buttonClose = $('.header__top__search__close');
              var currentExpandedClose = $buttonClose.attr('aria-expanded');
              var newExpandedClose = currentExpandedClose === 'true' ? 'false' : 'true';
              $buttonClose.attr('aria-expanded', newExpandedClose);

              const tabIndexElements = document.querySelectorAll('.header__top__search button, .header__top__search input');
              tabIndexElements.forEach(function (element) {
                var currentTabIndex = element.tabIndex;
                var newExpanded = currentTabIndex === -1 ? 0 : -1;
                element.setAttribute('tabIndex', newExpanded);
              });

              if($('.header__navigation').hasClass('open')) {
                $('.header').removeClass('header--nav-open');
                $('.header__navigation').removeClass('open');
                $("html, body").removeClass("noscroll");
                $('.header__top__nav-toggle__label').html('<i class="fa-solid fa-bars"></i>Menu');

                const tabIndexElements = document.querySelectorAll('.nav > li > a, .nav .nav__droptoggle');
                    tabIndexElements.forEach(function (element) {
                    element.setAttribute('tabIndex', -1);
                });
              }

                setTimeout(function() {
                  $('.header__top__search .searchform input').focus();
                }, 200);
            });

            $('.header__top__search .header__top__search__close').on("click", function(e) {
              e.preventDefault();

              var $button = $(this);
              var currentExpanded = $button.attr('aria-expanded');
              var newExpanded = currentExpanded === 'true' ? 'false' : 'true';
              $button.attr('aria-expanded', newExpanded);

              const tabIndexElements = document.querySelectorAll('.header__top__search button, .header__top__search input');
              tabIndexElements.forEach(function (element) {
                var currentTabIndex = element.tabIndex;
                var newExpanded = currentTabIndex === -1 ? 0 : -1;
                element.setAttribute('tabIndex', newExpanded);
              });

              $('.header__top__search').removeClass('header__top__search--active');
            });
        };
    };

    mobile_search();
    
/* ====================== SERVICE FINDER A-Z ======================  */

    $('.service-finder__letters button.letter').on("keydown, click", function(e) {
      e.preventDefault();
      $('.service-finder__letters button.letter').removeClass('letter--active').attr('aria-pressed', false);
      $('.service-finder__clear').addClass('service-finder__clear--show');
      $(this).addClass('letter--active').attr('aria-pressed', true);

      var filterValue = $(this).data("letter").toUpperCase(); // Get the filter value and convert it to uppercase
        $('.service-finder__results-group > li').each(function(index) {
          var letter = $(this).data('letter').toUpperCase(); // Get the site name from the first column and convert it to uppercase
          if (letter == filterValue || filterValue === '') { // If the site name includes the filter value or filter is empty
            $(this).show(); // Show the row
            $(this).attr('aria-hidden', false);
          } else {
            $(this).hide(); // Hide the row
            $(this).attr('aria-hidden', true);
          }
        });

      var elementToCheck = $(".service-finder__results");
      if (!isElementInViewport(elementToCheck)) {
            $('html, body').animate({
                scrollTop: elementToCheck.offset().top - 80
            }, 1000); // Change the duration as needed (in milliseconds)
      }
    });

    $('.service-finder__clear').on("click", function(e) {
        e.preventDefault();
        $(this).removeClass('service-finder__clear--show');
        $('.service-finder__letters button.letter').removeClass('letter--active');
        $('.service-finder__results-group > li').each(function(index) {
            $(this).show(); // Show the row
            $(this).attr('aria-hidden', false);
        });
    })

/* ====================== TRAVELINE INTEGRATION ======================  */
    const CONFIG = {
        tnjpID: "G-J4L3ER26JB",
         formContainerId: "journeyPlannerForm",
         resultsContainerId: "journeyPlannerResults",
         mode: "Mobile",
         callbacks: false,
         history: true,
         analytics: false,
         scrollWrapper: "journey-results-container",
    };
    window.onload = function() {
        if($('#journeyPlannerForm').length) {
            new MXDTraveline(CONFIG);
        }
    };

/* ====================== ORDER DOWNLOADS TABLE BY FILENAME SORT ======================  */
    var ascendingFileName = false;
    $('.download-search__list .sort--filename').on("click", function() {
        var table = $('#download-table');
        var columnIndex = 0; // Change this to the index of the column you want to sort
        var rows = table.find('tbody tr').get();

        rows.sort(function(a, b) {
        var aValue = $(a).find('td').eq(columnIndex).text();
        var bValue = $(b).find('td').eq(columnIndex).text();
        return ascendingFileName ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        });

        $.each(rows, function(index, row) {
        table.children('tbody').append(row);
        });

        ascendingFileName = !ascendingFileName;
        updateSortFileName();
    });
    
    if ($('.download-search__list').length) {
        var table = $('#download-table');
        var columnIndex = 0; // Change this to the index of the column you want to sort
        var rows = table.find('tbody tr').get();

        rows.sort(function(a, b) {
            var aValue = $(a).find('td').eq(columnIndex).text();
            var bValue = $(b).find('td').eq(columnIndex).text();
            return aValue.localeCompare(bValue);
        });

        $.each(rows, function(index, row) {
            table.children('tbody').append(row);
        });
    }


    function updateSortFileName() {
        $('#download-table .sort--date').removeClass('sort--desc');
        $('#download-table .sort--date').removeClass('sort--asc');

        if(ascendingFileName) {
            $('#download-table .sort--filename').addClass('sort--desc');
            $('#download-table .sort--filename').removeClass('sort--asc');
        } else {
            $('#download-table .sort--filename').removeClass('sort--desc');
            $('#download-table .sort--filename').addClass('sort--asc');
        }
    }

/* ======================  ADD HIDDEN SPAN TO ALL LINKS THAT OPEN IN NEW TAB ======================  */
  function addNoOpener(link) {
    let linkTypes = (link.getAttribute('rel') || '').split(' ');
    if (!linkTypes.includes('noopener')) {
      linkTypes.push('noopener');
    }
    link.setAttribute('rel', linkTypes.join(' ').trim());
  }

  function addNewTabMessage(link) {
    if (!link.querySelector('.screen-reader-only')) {
      link.insertAdjacentHTML('beforeend', '<span class="screen-reader-text">(opens in a new tab)</span>');
    }
  }

  document.querySelectorAll('a[target="_blank"]:not(.ignore-blank)').forEach(link => {
    addNoOpener(link);
    addNewTabMessage(link);
  });


/* ====================== SCROLL TO TOP BUTTON ======================  */
   var scrollToTopButton = $('#scrollToTop');

    // Function to check scroll position and toggle button visibility
    function toggleScrollButton() {
        var feedbackElement = $('.give-feedback');
        var feedbackElementTop = feedbackElement.offset().top - $(window).height();

        if ($(document).scrollTop() > feedbackElementTop) {
            scrollToTopButton.addClass('fixed');
        } else {
            scrollToTopButton.removeClass('fixed');
            if ($(document).scrollTop() > 500) {
                scrollToTopButton.css('display', 'block');
            } else {
                scrollToTopButton.css('display', 'none');
            }
        }

        
    }

    if(scrollToTopButton.length) {
        // Add a scroll event listener
        $(window).scroll(toggleScrollButton);
    }

    // Function to scroll to the top when the button is clicked
    scrollToTopButton.click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });


/* ====================== SEARCHFORM CLEAR ======================  */
    const inputFields = $(".searchform input[type='search']");
    const clearButtons = $(".searchform__clear");

    // Attach event listeners to each input field and clear button
    inputFields.each(function(index) {
        $(this).on("input", function() {
            // Show or hide the clear button based on input value
            clearButtons.eq(index).toggle($(this).val().length > 0);
        });

        clearButtons.eq(index).on("click", function() {
            // Clear the input and hide the clear button
            inputFields.eq(index).val("");
            $(this).hide();
        });
    });
});
